<template>
    <div>
        <div v-show="eventIsLoaded">
            <div v-show="!registrationFinishedSuccessful">
                <div class="event-registration-main">
                    <Notifications />
                    <div class="main-grid">
                        <div class="navigation-shadow" />
                        <div class="registration-header-shadow" />
                        <div class="registration-header px-4">
                            <EventTitleAndDate />
                            <div
                                v-if="chargeable"
                                class="price-box py-2 px-3">
                                <div class="d-flex align-items-end">
                                    <span>
                                        <span class="h4 mr-2">{{ $t('eventRegistration.invoicePreview.total') }}:</span>
                                        <span class="h1">
                                            <TotalPrice />
                                        </span>
                                    </span>
                                    <PriceTooltip>
                                        <span class="h1 ml-2 text-gray">
                                            <font-awesome-icon
                                                icon="info-circle" />
                                        </span>
                                    </PriceTooltip>
                                </div>
                            </div>
                        </div>
                        <div class="navigation">
                            <div class="my-3 mx-2">
                                <RegistrationMenu />
                            </div>
                            <div class="flex-grow-1" />
                            <AnbieterLogo class="logo-desktop" />
                        </div>
                        <div class="main-wrapper">
                            <div class="main">
                                <NuxtPage />
                            </div>
                            <div class="flex-grow-1" />
                            <div class="main-footer">
                                <Impressum />
                            </div>
                        </div>
                    </div>
                    <MobileFooter class="registration-footer" />
                </div>
            </div>
            <SuccessFinishPage v-if="registrationFinishedSuccessful" />
        </div>
        <div v-show="!eventIsLoaded">
            <div
                class="d-flex justify-content-center align-items-center"
                style="height: 100vh">
                <font-awesome-icon
                    icon="circle-notch"
                    spin
                    size="8x"
                    class="text-primary" />
            </div>
        </div>
    </div>
</template>
<script>
import AnbieterLogo from "@/components/layouts/eventRegistration/AnbieterLogo";
import EventTitleAndDate from "@/components/layouts/eventRegistration/EventTitleAndDate";
import PriceTooltip from "@/components/layouts/eventRegistration/PriceTooltip";
import RegistrationMenu from "@/components/layouts/eventRegistration/RegistrationMenu";
import MobileFooter from "@/components/layouts/eventRegistration/MobileFooter";
import TotalPrice from "@/components/layouts/eventRegistration/TotalPrice";
import registrationPriceMixin from "@/mixins/registration/registrationPriceMixin";
import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";
import registrationGroupMixin from "@/mixins/registration/registrationGroupMixin";
import SuccessFinishPage from "@/components/layouts/SuccessFinishPage";
import Impressum from "@/components/layouts/eventRegistration/Impressum";

export default {
    name: "EventRegistration",
    components: {
        Impressum,
        SuccessFinishPage,
        TotalPrice,
        MobileFooter,
        RegistrationMenu,
        PriceTooltip,
        EventTitleAndDate,
        AnbieterLogo
    },
    mixins: [registrationPriceMixin, mainRegistrationMixin, registrationGroupMixin]

}
</script>

<style lang="scss" scoped>


.main-grid {
    display: grid;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    grid-template-columns: $registration-navigation-width auto;
    grid-template-rows: $registration-header-height auto;
    grid-template-areas: "main main" "main main";
}

.registration-footer {
    display: block;
    z-index: 2;
}

@include media-breakpoint-down(sm) {
    .main-grid > :not(.main-wrapper) {
        display: none;
    }
}

@include media-breakpoint-up(md) {
    .registration-footer {
        display: none;
    }
    .main-grid {
        grid-template-areas: "header header" "navigation main";
    }
}


.navigation-shadow, .registration-header-shadow {
    box-shadow: $box-shadow;
    background: $white;
}

.navigation-shadow {
    grid-area: navigation;
}

.registration-header-shadow {
    grid-area: header;
}

.registration-header {
    grid-area: header;
    display: flex;
    align-items: center;
    background: $white;
}

.navigation {
    grid-area: navigation;
    display: flex;
    flex-direction: column;
    background: $white;
}

.price-box {
    box-shadow: $box-shadow;
    background: $white;
}

.main-wrapper {
    overflow: auto;
    grid-area: main;
    display: flex;
    flex-direction: column;
}

.main {
    margin: map-get($spacers, 3) map-get($spacers, 4);

    @include media-breakpoint-up(md) {
        margin: map-get($spacers, 4);
    }
}

.logo-desktop {
    height: calc(#{$registration-navigation-width} - #{$registration-navigation-width} / 2);
    width: calc(#{$registration-navigation-width} - #{$registration-navigation-width} / 2);
    margin: map-get($spacers, 2) auto;
}

.main-footer {
    display: flex;
    justify-content: flex-end;
    margin: map-get($spacers, 3) map-get($spacers, 4) calc(#{map-get($spacers, 3)} + #{$registration-mobile-footer-height-closed}) map-get($spacers, 4);

    @include media-breakpoint-up(md) {
        margin: map-get($spacers, 4);
    }
}

</style>
